// دليل الاستخدام السياقي — مصدر واحد لنصّ المساعدة في كل شاشة.
//
// لماذا هنا لا في كل شاشة على حدة: نصّ المساعدة المبعثر داخل الشاشات يتعفّن،
// لأن من يعدّل شاشةً يرى كودها لا شرحها. تجميعه في ملف واحد يجعل مراجعته
// دفعةً واحدة ممكنة، ويكشف التناقض بين شاشتين بمجرّد القراءة.
//
// اللقطات في public/guide/ وتُجلب عند فتح المساعدة لا مع التطبيق: صورة واحدة
// (~٨٠ ك.ب) لمن فتح مساعدة شاشة واحدة، ويخزّنها عامل الخدمة بعدها.

const SHOT = name => `guide/${name}.png`;

/**
 * مفاتيح الأقسام = مفاتيح الشاشات نفسها في app.js (screen أو sub)،
 * فيفتح الدليل على قسم الشاشة الحالية بلا خريطة وسيطة تُنسى عند إضافة شاشة.
 */
export const TOPICS = {

  auth: {
    title: 'الدخول والحساب',
    sub: 'اسم مستخدم وكلمة مرور — لا أكثر',
    shots: [
      { src: SHOT('01-login'), cap: 'شاشة الدخول' },
      { src: SHOT('02-register'), cap: 'حساب جديد' },
      { src: SHOT('03-recovery-code'), cap: 'رمز الاسترجاع — يظهر مرة واحدة' }
    ],
    points: [
      'لا يطلب التطبيق بريداً ولا رقم هاتف ولا رمز تحقّق. <b>اسم مستخدم وكلمة مرور</b> عند فتح الحساب وعند كل دخول.',
      '<b>اسم المستخدم:</b> أي اسم تتذكّره. لو كتبت بريداً أو رقم هاتف فهو مجرّد اسم — لا يُرسل إليه شيء.',
      '<b>كلمة المرور:</b> ثمانية أحرف على الأقل. جملة قصيرة تتذكّرها أقوى من رموز معقّدة تنساها.',
      '<b>عملة المحفظة</b> تُختار مرة واحدة فقط، ولن تُسأل عنها عند كل حركة.',
      '<b>⚠ رمز الاسترجاع</b> يظهر مرة واحدة بعد إنشاء الحساب. بلا بريد ولا رقم هاتف، هو وسيلتك الوحيدة لاستعادة الحساب إن نسيت كلمة المرور. احفظه خارج التطبيق.'
    ]
  },

  entry: {
    title: 'تسجيل حركة',
    sub: 'الشاشة التي تفتحها ٩٠٪ من الوقت',
    shots: [
      { src: SHOT('06-entry-filled'), cap: 'مبلغ + وجهة + نوع اختياري' },
      { src: SHOT('07-calculator'), cap: 'الحاسبة — تُفتح بالضغط على الرقم' },
      { src: SHOT('08-income'), cap: 'الدخل: وجهة بلا نوع' }
    ],
    points: [
      'حركة كاملة = <b>رقم + ضغطة على الوجهة + «تم»</b>. الترتيب لا يهم: تستطيع اختيار الوجهة قبل الرقم أو بعده.',
      '<b>النوع اختياري دائماً.</b> اتركه الآن وصنّفه لاحقاً من شاشة «صنّف لاحقاً».',
      'شريطا الوجهات والأنواع <b>يُسحبان يميناً ويساراً بالإصبع</b>، ومرتّبان بحسب استعمالك — الأكثر استخداماً أوّل ما تصله يدك.',
      '<b>اضغط على الرقم نفسه</b> (عليه علامة حاسبة صغيرة) لتفتح حاسبة بجمع وطرح وضرب وقسمة، بأولويات صحيحة.',
      'مبدّل <b>مصروف / دخل</b> في أعلى الشريط. الدخل له وجهة فقط — لا نوع.',
      'في الأعلى مجموع <b>الشهر حتى الآن</b>: تراه قبل أن تصرف، لا بعد أن تنسى.'
    ],
  },

  day: {
    title: 'مصروف يوم كامل',
    sub: 'المسار المسائي الهادئ',
    shots: [{ src: SHOT('09-day-full'), cap: 'بنود جاهزة + مطابقة الجيب' }],
    points: [
      'لتسجيل مصروف اليوم كلّه دفعة واحدة في المساء.',
      'البنود المعتادة <b>معروضة جاهزة</b> — تؤكّد أو تتجاوز، ولا تُسأل «ماذا صرفت؟» أمام شاشة فارغة.',
      'لكل بند <b>وجهة تلقائية</b> مأخوذة من عادتك (مواصلات ← أحمد).',
      'اضغط البند واكتب مبلغه؛ <b>اضغطه ثانيةً لتفتح الحاسبة</b>.',
      'سؤال <b>«كم كان معك نقداً هذا الصباح؟»</b> اختياري: الفرق بين النقد والمجموع يلتقط المصروفات الصغيرة المنسيّة.',
      'الشريط العلوي يتيح تسجيل <b>أمس</b> أو أوّل من أمس.'
    ],
  },

  split: {
    title: 'توزيع مبلغ واحد',
    sub: 'مبلغ واحد على عدة بنود',
    shots: [{ src: SHOT('10-split'), cap: 'محور قابل للقلب' }],
    points: [
      'لرسوم مدرسة على ثلاثة أولاد، أو فاتورة مول على عدة أنواع.',
      '<b>محور قابل للقلب:</b> «وزّع على وجهات» (نوع ثابت) أو «وزّع على أنواع» (وجهة ثابتة).',
      'اختر الثابت من الشريط، ثم اكتب مبلغاً أمام كل سطر.',
      'المجموع يتحدّث مع كل ضغطة، ويُحفظ كـ<b>حركات منفصلة</b> لا حركة واحدة — فتظهر كلٌّ في تقريرها.'
    ],
  },

  text: {
    title: 'سطر نصي',
    sub: 'اكتب الجملة كما تقولها',
    shots: [{ src: SHOT('11-text-line'), cap: 'جملة واحدة ← ثلاث حركات' }],
    points: [
      '<code>مدرسة أحمد ٥٠ وعلي ٤٠ وآية ٣٠</code> ← ثلاث حركات جاهزة.',
      'يفهم <b>الأرقام المكتوبة كلاماً</b> («مية وخمسين») وواو العطف والترتيب الحر: «قرطاسية آية ٥» و«آية ٥ قرطاسية» سواء.',
      'يميّز الدخل: <code>دخل ألفين شيكل راتب</code>.',
      'اضغط <b>«تحليل السطر»</b> لترى النتيجة <b>قبل</b> الحفظ، فتصحّح إن أخطأ.',
      'تحليل بقواعد لغوية لا ذكاء اصطناعي — يعمل بلا إنترنت ولا يُرسل نصّك لأي جهة.'
    ],
  },

  classify: {
    title: 'صنّف لاحقاً',
    sub: 'كومة الحركات بلا نوع',
    shots: [{ src: SHOT('12-classify'), cap: 'حركة واحدة في كل مرة' }],
    points: [
      'هنا تتجمّع الحركات التي سجّلتها بلا نوع — سجّل المبلغ عند الصندوق، وصنّف على الأريكة مساءً.',
      'حركة واحدة في كل مرة، والأنواع مرتّبة <b>الأرجح أوّلاً</b> بحسب وجهة الحركة وعادتك، فمعظمها تأكيد بنقرة.',
      '«تخطّي هذه» يؤجّلها، و«إنهاء» يخرج في أي لحظة.',
      'إن دخلتَ من تنبيه تقرير، فالكومة <b>مقصورة على فترة ذلك التقرير</b> — ويظهر زر لمتابعة الباقي بعدها.',
      'دقيقتان هنا في نهاية الأسبوع تجعلان تقرير «حسب النوع» كاملاً.'
    ],
  },

  log: {
    title: 'السجل',
    sub: 'شاشة تصحيح لا أرشيف',
    shots: [
      { src: SHOT('13-log'), cap: 'مجمّع بالأيام' },
      { src: SHOT('14-edit-entry'), cap: 'تعديل أو حذف' }
    ],
    points: [
      'وظيفته: «سجّلت رقماً خاطئاً قبل دقيقتين، أين أصلحه؟» — لذلك يعرض <b>آخر ٩٠ يوماً</b>. الماضي البعيد من التقرير بتحديد الفترة.',
      'الحركات مجمّعة <b>بالأيام</b> ومع كل يوم مجموعه.',
      'كل صف يحمل وسم <b>الوجهة</b> ووسم <b>النوع</b> — أو «بلا نوع» إن لم تُصنَّف.',
      'في المحفظة المشتركة يظهر <b>اسم من سجّل الحركة</b>.',
      '<b>اضغط أي حركة</b> لتعديل مبلغها أو وجهتها أو نوعها أو تاريخها، أو لحذفها.',
      'يحتاج اتصالاً: حركاتك محفوظة على الخادم لا على الجهاز، وهذا ما يُبقي التطبيق خفيفاً مهما طال تاريخك.'
    ],
  },

  edit: {
    title: 'تعديل حركة',
    sub: 'المبلغ والوجهة والنوع والتاريخ',
    shots: [{ src: SHOT('14-edit-entry'), cap: 'كل شيء قابل للتغيير' }],
    points: [
      'تصل إليها بالضغط على أي حركة في السجل أو داخل تفصيل بند في التقرير.',
      'الرقم هنا <b>يفتح الحاسبة</b> بنفس طريقة شاشة التسجيل.',
      '«حذف الحركة» في الأسفل، و«إلغاء» يخرج بلا تغيير.'
    ],
  },

  report: {
    title: 'التقارير',
    sub: 'ثلاث زوايا وسبع فترات',
    shots: [
      { src: SHOT('15-report-by-type'), cap: 'حسب النوع' },
      { src: SHOT('17-report-cross'), cap: 'التقاطع: البُعدان معاً' },
      { src: SHOT('19-report-custom-range'), cap: 'من تاريخ إلى تاريخ' }
    ],
    points: [
      '<b>ثلاث زوايا:</b> حسب النوع (على ماذا)، حسب الوجهة (لمن ولأين)، والتقاطع — جدول يجيب عن «كم صرفنا على مواصلات آية تحديداً؟».',
      '<b>الفترات:</b> اليوم · آخر ٧ أيام · هذا الشهر · الشهر السابق · ٣ أشهر · السنة · من — إلى.',
      'المقارنة تقيس <b>مدى زمنياً مساوياً</b> من الفترة السابقة، فلا تُقارن ٣ أيام بشهر كامل.',
      '<b>«بهذا المعدّل ستنهي الشهر عند…»</b> إسقاط مبكّر يعطيك فرصة للتصحيح قبل نهاية الشهر.',
      '<b>اضغط أي شريط</b> لترى الحركات التي كوّنته — ومنها تصل إلى الحركة الشاذة لتعديلها.',
      'إن ظهر <b>تنبيه أحمر</b> عن نسبة بلا نوع، فاضغطه: يفتح كومة تصنيف <b>هذه الفترة وحدها</b>.'
    ],
  },

  settings: {
    title: 'الإعدادات',
    sub: 'المشاركة والبنود والبيانات',
    shots: [
      { src: SHOT('21-settings-top'), cap: 'المزامنة والمحفظة المشتركة' },
      { src: SHOT('23-settings-bottom'), cap: 'العملات والمظهر والبيانات' }
    ],
    points: [
      '<b>رمز الدعوة:</b> شاركه مع زوجتك أو أبنائك ليسجّلوا في نفس المحفظة؛ تظهر حركات الجميع عند الجميع. «تجديد الرمز» يُبطل القديم.',
      '<b>الوجهات:</b> أبقِها قصيرة — فوق العشرين يصبح الاختيار أبطأ من الكتابة.',
      '<b>مفتاح «ثابت»</b> على النوع يعلّم ما لا تتحكّم به شهرياً (إيجار، فواتير، أقساط، مدرسة)، فيفصل التقرير ما تستطيع تقليصه عمّا لا تستطيع.',
      'حذف وجهة أو نوع <b>يؤرشفه ولا يمحو حركاته</b>؛ يظهر بوسم «مؤرشفة» مع زر إرجاع.',
      '<b>العملات:</b> كل حركة تُسجَّل بعملتها وتُحوَّل في التقارير فقط.',
      '<b>⚠ بياناتك على خادمك أنت</b> — تملكها بالكامل، والنسخ الاحتياطي مسؤوليتك. «تصدير نسخة» دقيقة واحدة كل شهر تكفي.'
    ],
  }
};

export const ORDER = ['auth', 'entry', 'day', 'split', 'text', 'classify',
                      'log', 'edit', 'report', 'settings'];

/** عناوين قصيرة لشريط التنقّل أسفل الورقة — العناوين الكاملة تطوّله. */
export const SHORT = {
  auth: 'الدخول', entry: 'تسجيل', day: 'يوم كامل', split: 'توزيع',
  text: 'سطر نصي', classify: 'صنّف لاحقاً', log: 'السجل',
  edit: 'تعديل', report: 'التقرير', settings: 'إعدادات'
};

export function topic(key){ return TOPICS[key] || null; }

/** مفتاح القسم المناسب للحالة الحالية — الشاشة الفرعية تسبق الرئيسية. */
export function keyFor(app){
  if (!app.session) return 'auth';
  if (app.sub && TOPICS[app.sub]) return app.sub;
  return TOPICS[app.screen] ? app.screen : 'entry';
}
